<template>
  <div class="kye-report-dgkp004" @click="handleClick('cardClick')">
    <div class="dgkp004_main-cell-title">
      <img
        class="dgkp004_main-icon1"
        :src="data.mainIcon1 || mainIcon1"
        @click="handleClick('mainIcon1')"
        v-events="{ eventsMap, ignoreEventName, args: ['mainIcon1', data.mainIcon1]}"
      />
      <div
        class="dgkp004_main-title"
        @click="handleClick('mainTitle')"
        v-events="{ eventsMap, ignoreEventName, args: ['mainTitle', data.mainTitle]}"
      >{{ data.mainTitle }}</div>
      <KyeReportCardQuestion
          class="dgkp004_main-icon2"
          :icon="data.mainIcon2"
          :popover="data.popover"
          @click="handleClick('mainIcon2')">
          <slot :name="'tooltip'"></slot>
      </KyeReportCardQuestion>
    </div>
    <div class="dgkp004_main-cell-index">
      <div class="dgkp004_main-cell-left">
        <div class="dgkp004_main-cell-left-top">
          <div class="dgkp004_main-index1-cell" @click="handleClick('mainIndex1')">
            <div
              class="dgkp004_main-index1"
              v-events="{ eventsMap, args: ['mainIndex1', data.mainIndex1]}"
            >{{ data.mainIndex1 }}</div>
            <div
              class="dgkp004_main-index1-unit"
              v-events="{ eventsMap, args: ['mainIndex1Unit', data.mainIndex1Unit]}"
            >{{ data.mainIndex1Unit }}</div>
          </div>
          <div
            class="dgkp004_main-index2-cell"
            :class="getIndexColor(data.mainIndex2Icon)"
            @click="handleClick('mainIndex2')">
            <div
              class="dgkp004_main-index2"
              v-events="{ eventsMap, args: ['mainIndex2', data.mainIndex2]}"
            >{{ data.mainIndex2 }}</div>
            <kyeReportCardArrow
              @click="handleClick('mainIndex2Icon', index)"
              class="dgkp004_main-icon3"
              :type="data.mainIndex2Icon"
              v-events="{ eventsMap, ignoreEventName, args: ['mainIndex2Icon', data.mainIndex2Icon]}"
            >
            </kyeReportCardArrow>
          </div>
        </div>
        <div class="dgkp004_main-cell-left-bottom">
          <div
            class="dgkp004_order-title"
            @click="handleClick('orderTitle')"
            v-events="{ eventsMap, ignoreEventName, args: ['orderTitle', data.orderTitle]}"
          >{{ data.orderTitle }}</div>
          <div class="dgkp004_order-index-cell" @click="handleClick('orderIndex1')">
            <div
              class="dgkp004_order-index1"
              v-events="{ eventsMap, args: ['orderIndex1', data.orderIndex1]}"
            >{{ data.orderIndex1 }}</div>
            <div
              class="dgkp004_order-index1-unit"
              v-events="{ eventsMap, args: ['orderIndex1Unit', data.orderIndex1Unit]}"
            >{{ data.orderIndex1Unit }}</div>
          </div>
          <div class="dgkp004_order-index2-cell" :class="getIndexColor(data.orderIndex2Icon)" @click="handleClick('orderIndex2')">
            <div
              class="dgkp004_order-index2"
              v-events="{ eventsMap, args: ['orderIndex2', data.orderIndex2]}"
            >{{ data.orderIndex2 }}</div>
            <kyeReportCardArrow
              @click="handleClick('orderIndex2Icon', index)"
              class="dgkp004_order-icon"
              :type="data.orderIndex2Icon"
              v-events="{ eventsMap, ignoreEventName, args: ['orderIndex2Icon', data.orderIndex2Icon]}"
            ></kyeReportCardArrow>
          </div>
        </div>
      </div>
      <div class="dgkp004_main-cell-right">
        <div class="dgkp004_list-cell-index" v-for="(item, index) in data.list" :key="index">
          <div
            class="dgkp004_list-title"
            @click="handleClick('listTitle', index)"
            v-events="{ eventsMap, ignoreEventName, args: ['listTitle', index, item.listTitle]}"
          >{{ item.listTitle }}</div>
          <div
            class="dgkp004_list-index"
            @click="handleClick('listIndex', index)"
            v-events="{ eventsMap, ignoreEventName, args: ['listIndex', index, item.listIndex]}"
          >{{ item.listIndex }}</div>
        </div>
      </div>
    </div>
    <card-popover
      :popoverConfig="popoverConfig"
    >
      <slot :name="cardPopoverSlotName"></slot>
    </card-popover>
  </div>
</template>
<script>
import mainIcon1 from '../../asset/images/dgkp004.png'
import kyeReportCardArrow from '../common/arrow.vue'
import KyeReportCardQuestion from '../common/question.vue'
export default {
  name: 'KyeReportDgkp004',
  components: {
    KyeReportCardQuestion,
    kyeReportCardArrow
  },
  props: {
    data: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      mainIcon1
    }
  },
  mounted() {
  },
  methods: {
    handleClick(eventName, index) {
      if (Number(index) >= 0) {
        this.$emit(eventName, index, this.data)
      } else {
        this.$emit(eventName, this.data)
      }
    },
    getIndexColor(type) {
      if (type === 'up') {
        return 'index-up-color'
      } else if (type === 'down') {
        return 'index-down-color'
      }
    }
  }
}
</script>
<style lang="scss">
.kye-report-dgkp004 {
  @import '../../style/extend.scss';
  background: #FFFFFF;
  border-radius: 4px;
  padding: 16px;
  flex-direction: column;
  cursor: pointer;
  position: relative;
  gap: 18px;
  display: flex;
  &::before {
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    width: 3px;
    border-radius: 4px 0 0 4px;
    background: linear-gradient(180deg, #AFA8FF 0%, #7B74FF 100%);
    content: '';
  }
  .dgkp004_main-cell-title {
    display: flex;
    flex-direction: row;
    align-items: center;
    color: #666666;
    font-size: 12px;
    gap: 4px;
    .dgkp004_main-icon1 {
      width: 12px;
      height: 12px;
    }
  }
  .dgkp004_main-cell-index {
    display: flex;
    flex-direction: row;
    .dgkp004_main-cell-left {
      display: flex;
      flex-direction: column;
      gap: 12px;
      .dgkp004_main-cell-left-top {
        display: flex;
        flex-direction: row;
        // align-items: center;
        .dgkp004_main-index1-cell {
          display: flex;
          flex-direction: row;
          align-items: center;
          color: var(--g-color-primary);
          font-weight: 600;
        }
        .dgkp004_main-index2-cell {
          display: flex;
          flex-direction: row;
          align-items: center;
        }
        .dgkp004_main-index1 {
          font-size: 16px;
          line-height: 16px;
        }
        .dgkp004_main-index1-unit {
          font-size: 12px;
          line-height: 12px;
          margin-left: 2px;
          display: flex;
          flex-direction: column-reverse;
        }
        .dgkp004_main-index2 {
          font-size: 12px;
          margin-left: 8px;
          line-height: 16px;
        }
      }
      .dgkp004_main-cell-left-bottom {
        display: flex;
        flex-direction: row;
        gap: 8px;
        align-items: center;
        font-size: 12px;
        .dgkp004_order-title {
          color: #999999;
          width: 80px;
          @extend %ellipse;
        }
        .dgkp004_order-index-cell {
          display: flex;
          flex-direction: row;
          color: var(--g-color-primary);
          .dgkp004_order-index1 {
            font-weight: 600;
          }
        }
        .dgkp004_order-index2-cell {
          display: flex;
          flex-direction: row;
          gap: 2px;
        }
      }
    }
    .dgkp004_main-cell-right {
      display: flex;
      flex-direction: column;
      gap: 12px;
      padding-left: 12px;
      margin-left: 12px;
      position: relative;
      flex-wrap: wrap;
      height: 48px;
      &::before {
        position: absolute;
        content: '';
        top: 0;
        left: 0;
        bottom: 0;
        width: 0.5px;
        background:  #EBEDF5;
      }
      .dgkp004_list-cell-index {
        display: flex;
        flex-direction: row;
        font-size: 12px;
        color: #999999;
        align-items: center;
        .dgkp004_list-index {
          color: var(--g-color-primary);
          font-weight: 600;
          margin-left: 8px;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/public/components/kye-report-form/card/dgkp004/index.vue